import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { PaymentGatewayBot } from '@core/models/payment-gateway-bot.model';

@Injectable()
export class PaymentGatewayBotEntityService extends EntityCollectionServiceBase<PaymentGatewayBot> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('PaymentGatewayBot', serviceElementsFactory);
    }
}